import React from 'react';
import { Box, Stack, Card, CardContent, Skeleton } from '@mui/material';
import { Row } from 'components/Row/Row';

export function SectionDetailSkeleton({ isLoading }: { isLoading: boolean }) {
  return (
    isLoading && (
      <Stack sx={{ width: '100%' }} gap={1} data-testid='section-detail-skeleton'>
        {/* Header Skeleton */}
        <Box p={2}>
          <Row justifyContent='space-between' alignItems='center'>
            {/* EditableInputField Skeleton */}
            <Skeleton variant='text' width='50%' height={40} />
            {/* IconButton Skeleton */}
            <Skeleton variant='circular' width={30} height={30} />
          </Row>
        </Box>

        {/* Divider Skeleton */}
        <Skeleton variant='rectangular' height={2} />

        {/* Scroll container Skeleton */}
        <Stack gap={1} p={3}>
          {/* Lecture Step Skeleton */}
          <Card sx={{ bgcolor: 'surfaceContainer.main' }}>
            <CardContent>
              <Stack gap={1}>
                <Skeleton height={40} width='50%' />
                <Skeleton variant='rounded' height={150} />
                <Row gap={2}>
                  <Skeleton width='30%' />
                  <Skeleton variant='rounded' width={50} />
                </Row>
                <Row gap={2}>
                  <Skeleton width='30%' />
                  <Skeleton variant='rounded' width={50} />
                </Row>
                <Row gap={2}>
                  <Skeleton width='30%' />
                  <Skeleton variant='rounded' width={50} />
                </Row>
              </Stack>
            </CardContent>
          </Card>

          {/* Knowledge Check Skeleton */}
          <Card sx={{ bgcolor: 'surfaceContainer.main' }}>
            <CardContent>
              <Stack gap={1}>
                <Skeleton height={40} width='50%' />
                <Skeleton variant='rounded' height={100} />
                <Row gap={2}>
                  <Skeleton width='30%' />
                  <Skeleton variant='rounded' width={50} />
                </Row>
                <Row gap={2}>
                  <Skeleton width='30%' />
                  <Skeleton variant='rounded' width={50} />
                </Row>
                <Row gap={2}>
                  <Skeleton width='30%' />
                  <Skeleton variant='rounded' width={50} />
                </Row>
                <Skeleton variant='rounded' height={200} />
              </Stack>
            </CardContent>
          </Card>
        </Stack>
      </Stack>
    )
  );
}
